export default "__VITE_ASSET__BZLXmuW2__"